// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"b631ccba","551":"bda5dff0","719":"be7c2a91","905":"10a24547"}[chunkId] + ".chunk.js";
};